import { z } from 'zod';

import { ErrorCodeSchema } from './errors';

/** Standard error response body for every non-2xx API response. */
export const ApiErrorBodySchema = z.object({
  error: z.object({
    code: ErrorCodeSchema,
    message: z.string(),
    /** Field-level issues for validation errors, or arbitrary structured context. */
    details: z.unknown().optional(),
    requestId: z.string().optional(),
  }),
});
export type ApiErrorBody = z.infer<typeof ApiErrorBodySchema>;

/** Cursor/offset page metadata returned alongside list payloads. */
export const PageMetaSchema = z.object({
  total: z.number().int().nonnegative().optional(),
  page: z.number().int().positive().optional(),
  pageSize: z.number().int().positive(),
  pageCount: z.number().int().nonnegative().optional(),
  nextCursor: z.string().nullable().optional(),
  prevCursor: z.string().nullable().optional(),
});
export type PageMeta = z.infer<typeof PageMetaSchema>;

/** Wrap a list of `item` schemas into the `{ data, page }` collection envelope. */
export const listResponse = <T extends z.ZodTypeAny>(item: T) =>
  z.object({ data: z.array(item), page: PageMetaSchema });

export interface ListResponse<T> {
  data: T[];
  page: PageMeta;
}
